var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mini-avatar"},[_c('img',{staticClass:"wp-post-image",attrs:{"alt":"","src":_vm.avatarUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }